import React, { useMemo } from 'react';

import { DateFormat, formatDateWithYear } from '@lyearn/core/utils/date/formatDate';
import { cn } from '@lyearn/style';
import { Typography } from '@lyearn/ui';

import { CreatedOnProps } from '../../types';

function CreatedAt({ className = 'ps-4', createdAt }: CreatedOnProps & { createdAt: string }) {
  const formattedCreatedOn = useMemo(
    () => formatDateWithYear(createdAt, DateFormat.Date),
    [createdAt],
  );

  return (
    <Typography
      className={cn(className, 'truncate')}
      color="text-text-secondary"
      variant="body-short-02">
      {formattedCreatedOn}
    </Typography>
  );
}
export default CreatedAt;
